(function () {
  const slideshow = document.querySelector('[data-slideshow]');
  if (!slideshow) return;

  const container = slideshow.querySelector('.custom-blog-posts-container');
  const loader = slideshow.querySelector('.slideshow-loader');

  let currentPage = parseInt(slideshow.dataset.currentPage, 10);
  const totalPages = parseInt(slideshow.dataset.totalPages, 10);
  const blogHandle = slideshow.dataset.blogHandle;

  let isLoading = false;
  let index = 0;
  let isDragging = false;
  let startX = 0;
  let startIndex = 0;
  let didDrag = false;
  let startTouchX = 0;

  function update() {
    const slides = container.querySelectorAll('.blog-slide');
    if (!slides.length) return;

    const slideWidth = slides[0].getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(container).gap) || 0;

    const totalWidth = slides.length * slideWidth + (slides.length - 1) * gap;

    const containerStyles = getComputedStyle(container);
    const marginLeft = parseFloat(containerStyles.marginLeft) || 0;
    const marginRight = parseFloat(containerStyles.marginRight) || 0;

    const viewportWidth = slideshow.getBoundingClientRect().width - marginLeft - marginRight;

    const maxTranslate = Math.max(0, totalWidth - viewportWidth);

    const desiredTranslate = index * (slideWidth + gap);

    const clampedTranslate = Math.min(desiredTranslate, maxTranslate);

    container.style.transform = 'translateX(' + -clampedTranslate + 'px)';
  }

  function getMaxIndex() {
    const slides = container.querySelectorAll('.blog-slide');
    if (!slides.length) return 0;

    const slideWidth = slides[0].getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(container).gap) || 0;

    const containerStyles = getComputedStyle(container);
    const marginLeft = parseFloat(containerStyles.marginLeft) || 0;
    const marginRight = parseFloat(containerStyles.marginRight) || 0;

    const viewportWidth = slideshow.getBoundingClientRect().width - marginLeft - marginRight;

    const slidesFit = (viewportWidth + gap) / (slideWidth + gap);

    return Math.max(0, Math.ceil(slides.length - slidesFit));
  }

  function shouldLoadMore() {
    return index >= getMaxIndex() - 1;
  }

  async function loadMore() {
    if (isLoading || currentPage >= totalPages) return;

    isLoading = true;
    loader.hidden = false;

    try {
      const nextPage = currentPage + 1;
      const response = await fetch(`/blogs/${blogHandle}?page=${nextPage}`);
      if (!response.ok) {
        throw new Error(`Failed to fetch: ${response.status} ${response.statusText}`);
      }
      const text = await response.text();

      const doc = new DOMParser().parseFromString(text, 'text/html');
      const newSlides = doc.querySelectorAll('.blog-slide');

      newSlides.forEach((slide) => {
        container.appendChild(slide);
      });

      currentPage = nextPage;
    } catch (e) {
      console.error('Failed to load more articles', e);
    } finally {
      loader.hidden = true;
      isLoading = false;
      update();
    }
  }

  slideshow.querySelector('[data-slide-next]').addEventListener('click', async () => {
    const maxIndexBefore = getMaxIndex();
    const slidesBefore = container.querySelectorAll('.blog-slide').length;

    if (index < maxIndexBefore) {
      index++;
      update();
    }

    if (shouldLoadMore()) {
      await loadMore();
    }

    const slidesAfter = container.querySelectorAll('.blog-slide').length;
    const maxIndexAfter = getMaxIndex();

    if (slidesAfter > slidesBefore && index === maxIndexBefore && index < maxIndexAfter) {
      index++;
      update();
    }

    if (index > maxIndexAfter) {
      // If no more slides exist, either stop or loop
      index = currentPage >= totalPages ? 0 : maxIndexAfter;
      update();
    }
  });

  slideshow.querySelector('[data-slide-prev]').addEventListener('click', () => {
    if (index === 0) return;
    index--;
    update();
  });

  // Prevent click after drag
  container.addEventListener(
    'click',
    (e) => {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }
    },
    true
  );

  // Mouse drag support (desktop only)
  container.addEventListener('mousedown', (e) => {
    if (e.button !== 0) return; // left mouse only
    e.preventDefault();

    isDragging = true;
    startX = e.clientX;
    startIndex = index;
    didDrag = false;

    container.style.cursor = 'grabbing';
    container.style.userSelect = 'none';
  });

  // Touch drag support (mobile & tablet)
  container.addEventListener('touchstart', (e) => {
    if (e.touches.length !== 1) return;

    isDragging = true;
    startTouchX = e.touches[0].clientX;
    startIndex = index;
    didDrag = false;
  }, { passive: true });

  container.addEventListener('touchmove', (e) => {
    if (!isDragging) return;

    const slides = container.querySelectorAll('.blog-slide');
    if (!slides.length) return;

    const slideWidth = slides[0].getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(container).gap) || 0;

    const deltaX = e.touches[0].clientX - startTouchX;
    if (Math.abs(deltaX) > 5) didDrag = true;

    const threshold = (slideWidth + gap) / 4;
    if (Math.abs(deltaX) < threshold) return;

    const direction = deltaX > 0 ? -1 : 1;
    index = Math.max(0, Math.min(startIndex + direction, getMaxIndex()));

    update();
  }, { passive: true });

  container.addEventListener('touchend', async () => {
    isDragging = false;

    if (shouldLoadMore()) {
      await loadMore();
    }
  });

  window.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();

    const slides = container.querySelectorAll('.blog-slide');
    if (!slides.length) return;

    const slideWidth = slides[0].getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(container).gap) || 0;

    const deltaX = e.clientX - startX;
    if (Math.abs(deltaX) > 5) didDrag = true;

    // Require some movement before changing slide
    const threshold = (slideWidth + gap) / 4;
    if (Math.abs(deltaX) < threshold) return;

    const direction = deltaX > 0 ? -1 : 1;
    index = Math.max(0, Math.min(startIndex + direction, getMaxIndex()));

    update();
  });

  async function stopDrag() {
    if (!isDragging) return;
    isDragging = false;
    container.style.cursor = '';
    container.style.userSelect = '';

    if (shouldLoadMore()) {
      await loadMore();
    }
  }

  window.addEventListener('mouseup', stopDrag);
  window.addEventListener('mouseleave', stopDrag);
  window.addEventListener('resize', update);
})();


function syncSlideshowControlsHeight() {
  const slideshow = document.querySelector('.blog-slideshow');
  if (!slideshow) return;

  const image = slideshow.querySelector('.blog-post-card__image-container');
  const controls = slideshow.querySelector('.slideshow-controls-container');

  if (!image || !controls) return;

  const rect = image.getBoundingClientRect();
  controls.style.height = rect.height + 'px';
}

window.addEventListener('load', syncSlideshowControlsHeight);
window.addEventListener('resize', syncSlideshowControlsHeight);

